import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nomination-rec-form',
  templateUrl: './nomination-rec-form.component.html',
  styleUrls: ['./nomination-rec-form.component.css']
})
export class NominationRecFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Nomination/nomination-rec/nomination-rec-form/nomination-rec-form.component.ts